// import LogoM from '@/assets/svg/icons/Logo-M.svg';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
// import { addBearerToken } from '@/utils/authFetch';
import { useEffect } from 'react';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { isE2EModeEnabled } from '../utils/runtimeMode';

const Splash = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    const login = async () => {
      try {
        if (isE2EModeEnabled()) {
          navigate('/upload', { replace: true });
          return;
        }

        const active = instance.getActiveAccount();
        if(active) {
          navigate("/upload", { replace: true });
          return;
        }

        const accounts = instance.getAllAccounts();
        if(accounts.length > 0) {

          // instance.setActiveAccount(accounts[0]);
          try {
          
          await instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
          });
        
          instance.setActiveAccount(accounts[0]);

          navigate("/upload", { replace: true });
          return;
        } catch(err) {
          if(err instanceof InteractionRequiredAuthError){
            console.info("Silent login failed, redirecting to login...");
            await instance.loginRedirect(loginRequest);
          } else {
            console.error("Silent login error", err);
          }
        }
      }

      await instance.loginRedirect(loginRequest);
        
      } catch(error) {
        // if(error instanceof InteractionRequiredAuthError){
        //   instance.loginRedirect(loginRequest);
        // } else {
        console.error("Login error", error);
      }
    }


    login();
  }, [instance, navigate]);

  return null;

};

export default Splash;
